// extracted by mini-css-extract-plugin
export default {"root":"Measurement_root__hkzrq"};